__turbopack_context__.v({
  "a": "regional-agent-module__76tr_G__a",
  "applicationClose": "regional-agent-module__76tr_G__applicationClose",
  "applicationDialog": "regional-agent-module__76tr_G__applicationDialog",
  "applicationForm": "regional-agent-module__76tr_G__applicationForm",
  "applicationPrivacy": "regional-agent-module__76tr_G__applicationPrivacy",
  "btn": "regional-agent-module__76tr_G__btn",
  "btn-primary": "regional-agent-module__76tr_G__btn-primary",
  "btn-secondary": "regional-agent-module__76tr_G__btn-secondary",
  "chinaMap": "regional-agent-module__76tr_G__chinaMap",
  "cta": "regional-agent-module__76tr_G__cta",
  "eyebrow": "regional-agent-module__76tr_G__eyebrow",
  "hero": "regional-agent-module__76tr_G__hero",
  "hero-copy": "regional-agent-module__76tr_G__hero-copy",
  "hero-cta": "regional-agent-module__76tr_G__hero-cta",
  "hero-img": "regional-agent-module__76tr_G__hero-img",
  "kicker": "regional-agent-module__76tr_G__kicker",
  "label": "regional-agent-module__76tr_G__label",
  "lead": "regional-agent-module__76tr_G__lead",
  "mapCity": "regional-agent-module__76tr_G__mapCity",
  "mapCityRing": "regional-agent-module__76tr_G__mapCityRing",
  "mapInsetFrame": "regional-agent-module__76tr_G__mapInsetFrame",
  "mapInsetLabel": "regional-agent-module__76tr_G__mapInsetLabel",
  "mapLand": "regional-agent-module__76tr_G__mapLand",
  "page": "regional-agent-module__76tr_G__page",
  "redline": "regional-agent-module__76tr_G__redline",
  "redline-item": "regional-agent-module__76tr_G__redline-item",
  "row": "regional-agent-module__76tr_G__row",
  "s": "regional-agent-module__76tr_G__s",
  "sec": "regional-agent-module__76tr_G__sec",
  "sec-body": "regional-agent-module__76tr_G__sec-body",
  "security": "regional-agent-module__76tr_G__security",
  "spec": "regional-agent-module__76tr_G__spec",
  "spec-note": "regional-agent-module__76tr_G__spec-note",
  "specs": "regional-agent-module__76tr_G__specs",
  "tier": "regional-agent-module__76tr_G__tier",
  "tier-head": "regional-agent-module__76tr_G__tier-head",
  "tiers": "regional-agent-module__76tr_G__tiers",
  "timer": "regional-agent-module__76tr_G__timer",
  "wrap": "regional-agent-module__76tr_G__wrap",
});
